import { IconProps } from "../../utils/global-types/global-types";

const VerbasmsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      className={
        className
          ? className
          : "w-4.5 h-4.5 text-verba-sms dark:text-verba-sms-dk"
      }
      {...rest}
    >
      <path
        fill="currentColor"
        d="M0 3.556A3.556 3.556 0 0 1 3.556 0h8.888A3.556 3.556 0 0 1 16 3.556v8.888A3.556 3.556 0 0 1 12.444 16H3.556A3.556 3.556 0 0 1 0 12.444z"
      ></path>
      <path
        fill="#FBFBFB"
        d="M3.345 12.626c.278-.13.547-.561.736-1.172-1.113-.947-1.741-2.253-1.741-3.617 0-2.782 2.585-5.049 5.767-5.049 2.8 0 5.174 1.737 5.668 4.143q0 .015.009.022a.4.4 0 0 1 .013.08q.076.379.076.804c0 2.751-2.549 5.013-5.69 5.045-.09.008-.18 0-.296 0a6.4 6.4 0 0 1-1.392-.198c-.978.583-2.706.772-2.912.794h-.045a.447.447 0 0 1-.189-.852zM10.39 8.56a.72.72 0 0 0 .718-.718.72.72 0 0 0-.718-.718.72.72 0 0 0-.718.718.72.72 0 0 0 .718.718m-2.284 0a.72.72 0 0 0 .718-.718.72.72 0 0 0-.718-.718.72.72 0 0 0-.719.718.72.72 0 0 0 .719.718m-2.28 0a.72.72 0 0 0 .718-.718.72.72 0 0 0-.718-.718.72.72 0 0 0-.718.718.72.72 0 0 0 .718.718"
      ></path>
    </svg>
  );
};

export default VerbasmsIcon;
